
      import { Buffer } from 'buffer'
      window.Buffer = window.Buffer || Buffer

      var env = 'dev'

      if (env !== 'release') {
        console.info(`environment: ${env}`)
      }
    